const BASE_DOMAIN = 'saledesk.pk';
const RESERVED_SUBDOMAINS = new Set(['pos', 'devpos', 'devapi', 'www', 'app', 'api', 'admin', 'ksa', 'ksaapi', 'devksa', 'devksaapi']);

export type TenantLoginContext = {
  isTenantLogin: boolean;
  subdomain: string | null;
};

export function getTenantLoginContext(hostname = window.location.hostname): TenantLoginContext {
  const host = hostname.toLowerCase();
  if (!host || host === 'localhost' || host === '127.0.0.1' || host === BASE_DOMAIN) {
    return { isTenantLogin: false, subdomain: null };
  }

  const suffix = `.${BASE_DOMAIN}`;
  if (!host.endsWith(suffix)) {
    return { isTenantLogin: false, subdomain: null };
  }

  const subdomain = host.slice(0, -suffix.length);
  if (!subdomain || subdomain.includes('.') || RESERVED_SUBDOMAINS.has(subdomain)) {
    return { isTenantLogin: false, subdomain: null };
  }

  return { isTenantLogin: true, subdomain };
}
